import React, { FC, useState } from "react";
import Documents from "./Tabs/Documents";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Wrapper } from "../styled";

const foramtionDocumentsTabs = [
  {
    title: "Формирование документов",
    component: <Documents/>,
  },
];


const FormationDocuments: FC = () => {
  const [tab, setTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {foramtionDocumentsTabs.map((tab) => (
          <Tab key={tab.title} label={tab.title} />
        ))}
      </Tabs>
      {foramtionDocumentsTabs[tab].component}
    </Wrapper>
  );
};

export default FormationDocuments;
